"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHandler = toHandler;
exports.toResolver = toResolver;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PathProxy = _interopRequireDefault(require("./PathProxy"));

var _JSONLDResolver = _interopRequireDefault(require("./JSONLDResolver"));

var _defaultHandlers = _interopRequireDefault(require("./defaultHandlers"));

var _jsonldContextParser = require("jsonld-context-parser");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * A PathFactory creates paths with default settings.
 */


var PathFactory =
/*#__PURE__*/
function () {
  function PathFactory(settings, data) {
    _classCallCheck(this, PathFactory);

    // Store settings and data
    this._settings = settings = _objectSpread({}, settings);
    this._data = data = _objectSpread({}, data); // Prepare the handlers

    var handlers = settings.handlers || _defaultHandlers.default;

    for (var key in handlers) {
      handlers[key] = toHandler(handlers[key]);
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.getOwnPropertySymbols(handlers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _key = _step.value;
        handlers[_key] = toHandler(handlers[_key]);
      } // Prepare the resolvers

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var resolvers = (settings.resolvers || []).map(toResolver);

    if (settings.context) {
      resolvers.push(new _JSONLDResolver.default(settings.context));
      settings.parsedContext = new _jsonldContextParser.ContextParser().parse(settings.context);
    } else {
      settings.context = settings.parsedContext = {};
    } // Instantiate PathProxy that will create the paths


    this._pathProxy = new _PathProxy.default({
      handlers: handlers,
      resolvers: resolvers
    }); // Remove PathProxy settings from the settings object

    delete settings.handlers;
    delete settings.resolvers;
  }
  /**
   * Creates a path with the given (optional) settings and data.
   */


  _createClass(PathFactory, [{
    key: "create",
    value: function create() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var data = arguments.length > 1 ? arguments[1] : undefined;

      // The settings parameter is optional
      if (!data) {
        var _ref = [settings, null];
        data = _ref[0];
        settings = _ref[1];
      } // Apply defaults on settings and data


      return this._pathProxy.createPath(Object.assign(Object.create(null), this._settings, settings), Object.assign(Object.create(null), this._data, data));
    }
  }]);

  return PathFactory;
}();

exports.default = PathFactory;
PathFactory.defaultHandlers = _defaultHandlers.default;
/**
 * Converts a handler function into a handler object.
 */

function toHandler(handle) {
  return typeof handle.handle === 'function' ? handle : {
    handle: handle
  };
}
/**
 * Converts a resolver function into a catch-all resolver object.
 */


function toResolver(resolve) {
  return typeof resolve.resolve === 'function' ? resolve : {
    supports: supports,
    resolve: resolve
  };
} // Catch-all resolvers support everything


function supports() {
  return true;
}